// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f73cf9c1","849":"6803ac58"}[chunkId] + ".chunk.js";
};